export default {
  title: 'ROAS por Canal',
  xAxisName: 'Canal',
  mean: 'Media',
  lower: 'Inferior',
  upper: 'Superior',
  crossUnitWarning: 'Cada barra es el {kpi} que el modelo atribuye al canal dividido por lo que se gastó en él, y las dos cosas están medidas en unidades distintas. Por eso el eje y no está en "veces lo invertido" sino en {unit}: el {kpi} que trajo cada unidad de gasto. Los canales siguen siendo comparables entre sí y el rango de confianza sigue valiendo; lo que no aplica es compararlos contra el ROAS de un modelo donde {kpi} y gasto comparten unidad.',
  dataView: 'Vista de Datos',
  close: 'Cerrar',
  refresh: 'Actualizar',
  saveAsImage: 'Guardar como Imagen'
}
